import { UIElement } from './uiElement';
import { IUIElementOptions } from '../../../interfaces/options';
import { Templates } from '../../../compile';

export class Textarea extends UIElement<string> {
	constructor(
		id: string,
		label: string,
		value: string | KnockoutObservable<string>,
		options?: IUIElementOptions
	) {
		options = $.extend(
			true,
			{},
			<IUIElementOptions>{
				widget: {
					widget: Templates.widgets_textarea
				}
			},
			options || {}
		);
		super(id, label, value, options);
	}
}
